import { Radio } from 'antd';

const RadioButtonTeam = ({
  circles,
  size,
  index,
  col,
  id,
  max_size,
  min_size,
  name,
}: any) => {
  return (
    <Radio.Button
      className="min-w-[13rem] max-xl:min-w-[12rem] h-[13rem] max-md:h-[70px] !rounded-xl radio-btn-holder transition-all py-[32px] px-[18px] max-md:px-3 max-md:py-4"
      value={id}
    >
      <div
        className={`flex md:flex-col w-full items-center justify-between max-md:justify-start max-md:gap-4 h-full gap-4 ${
          index === 0
            ? 'gap-y-12'
            : index === 1
            ? 'gap-y-12'
            : index === 2
            ? 'gap-y-8'
            : index === 3
            ? 'gap-y-4'
            : ''
        }`}
      >
        <div
          className={`max-md:!grid-flow-col w-fit !h-fit max-md:w-fit max-md:!grid-rows-2   ${
            index === 1
              ? 'gap-3 max-md:-ml-8'
              : index === 2
              ? 'gap-x-3 gap-y-2'
              : 'gap-2'
          }`}
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${col}, 1fr)`,
            justifyItems: 'center',
            alignItems: 'center',
          }}
        >
          {circles.map((e: any, i: any) => {
            return (
              <div
                style={{
                  background: e,
                  width: size,
                  height: size,
                  gridRowEnd: index === 0 ? 'span 2' : '',
                }}
                className={`rounded-full ${
                  index === 3
                    ? 'max-md:!w-[16px] max-md:!h-[16px]'
                    : 'max-md:!w-[18px] max-md:!h-[18px]'
                }`}
              />
            );
          })}
        </div>
        <div className="md:h-1/2 flex flex-col max-md:flex-col-reverse md:items-center md:justify-center gap-y-2 md:mt-auto">
          <span className="w-full h-fit text-black text-color-gray text-lg max-md:text-sm">
            {name?.ar || name}
          </span>
          <span className="w-fit h-fit text-black text-color-primary font-semibold text-lg max-md:text-sm">
            {max_size ? `${min_size}-${max_size}` : min_size}
          </span>
        </div>
      </div>
    </Radio.Button>
  );
};

export default RadioButtonTeam;
